import { combineReducers } from 'redux';
import { credit_card } from './credit_card_reducer';

const rootReducer = combineReducers({
  credit_card
});

export default rootReducer;